import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
//Moment
import moment from 'moment-timezone';
import 'moment/locale/ja';
//Component
import Map from './Map';
moment.locale('ja');
//moment.tz.setDefault('Asia/Tokyo');

class MapsDetail extends Component {
  render() {
    const { currentHeight, eventInfo = {}, stateInfo = {} } = this.props;

    let eventDate = eventInfo.eventDate;
    let duration = Number(eventInfo.duration);
    let eventTime = eventDate;

    const date = moment(eventDate).format('YYYY/MM/DD (ddd)');
    const timestart = moment(eventTime).local().format('HH:mm');
    const timeend = moment(eventTime).add(duration, 'minutes').local().format('HH:mm');

    return (
      <div className="details-card" style={{ top: (currentHeight + 96) + 'px' }}>
        <div className="date-time-loc">
          <div className="row-detail">
            <div className="icon">
              <img src="/images/icon-grey-copy-2.svg" alt="calendar" className="info-items-icon" />
            </div>
            <div className="info-items-text"> {date} </div>
          </div>
          <div className="row-detail">
            <div className="icon">
              <img src="/images/combined-shape.svg" alt="clock" className="info-items-icon" />
            </div>
            <div className="info-items-text"> {timestart + '~' + timeend} </div>
          </div>
          <div className="row-detail">
            <div className="icon">
              <img src="/images/shape.svg" alt="pin" className="info-items-icon" />
            </div>
            <div title={eventInfo.location} className="info-items-text"><span>{eventInfo.location}</span> </div>
          </div>
        </div>
        {/*  Map */}
        { !stateInfo.eventPreview && 
          (
            <div className="map-container">
              <Map eventInfo={eventInfo} />
            </div>
          )
        }
        {/* Notify text for offer event */}
        {_get(eventInfo, 'offerEvent', false) && (
          <div className="offer-event-notify">
            <strong>
              ※こちらの日時・場所は仮で入力されたものです。
            </strong>
            <br/>
            オファーをくれた社長の話を聞いてみたい場合は、
            <br />
            「チャットをはじめる」ボタンからコンタクトをして日時・場所を決定してください。
          </div>
        )}
      </div>
    );
  }
}

MapsDetail.propTypes = {
  currentHeight: PropTypes.any, 
  eventInfo: PropTypes.any, 
  stateInfo: PropTypes.any
};


export default MapsDetail;
